define('presentation/common/actionModal/viewModels/deleteCallQueueActionViewModel',[
    'common/promises/promiseFactory',
    'common/storage/commonState',
], function() {
    return function(callQueue) {
        const PromiseFactoryConstructor = require('common/promises/promiseFactory');
        const _promiseFactory = new PromiseFactoryConstructor();

        const _commonState = require('common/storage/commonState');
        const _i18n = require('i18next');

        const self = this;

        self.callQueue = callQueue;
        self.name = callQueue.name;
        self.iconName = callQueue.iconName;
        self.objectName = _commonState.typeDisplay.callQueue.toLowerCase();
        self.metadata = _i18n.t('callQueues:poolSummary', {
            count: callQueue.poolCount,
            maxCallers: callQueue.maxCallersInQueue
        });

        self.activate = () => {
            return _promiseFactory.wait();
        };
    };
});

